import { useState, useEffect, useCallback } from 'react';
import { getRequest } from '../api/ApiController';

/**
 * Zoznam šablón údržby: donačítava sa z API (už nie v state pri logine).
 * @returns {{ maintenanceTemplates: Array, loading: boolean, refetch: function }}
 */
export function useMaintenanceTemplates() {
  const [maintenanceTemplates, setMaintenanceTemplates] = useState([]);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(() => {
    setLoading(true);
    getRequest('/api/maintenance_templates')
      .then((r) => {
        const list = r?.data ?? r ?? [];
        setMaintenanceTemplates(Array.isArray(list) ? list : []);
      })
      .catch(() => setMaintenanceTemplates([]))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { maintenanceTemplates, loading, refetch };
}
